import request from '@/utils/request'
export function GetDashboard() { //
  return request({
    url: 'Common/GetDashboard',
    method: 'get'
  })
}
export function GetStatistics(data) { // 平台统计
  return request({
    url: 'Statistics/GetAllHospitalStatistics',
    method: 'get',
    params: data
  })
}
export function GetProceduresStatisticsByDate(data) { // 获取按时间统计检查数
  return request({
    url: 'Statistics/GetProceduresStatisticsByDate',
    method: 'get',
    params: data
  })
}
export function GetAvgMinsStatisticsByDate(data) { // 获取按时间统计平均诊断时间
  return request({
    url: 'Statistics/GetAvgMinsStatisticsByDate',
    method: 'get',
    params: data
  })
}
export function GetPersonalProceduresByDate(data) { // 个人近30天或近一年诊断数量
  return request({
    url: 'Statistics/GetPersonalProceduresByDate',
    method: 'get',
    params: data
  })
}
export function GetPersonalAvgMinsByDate(data) { // 个人按时间统计平均诊断时间
  return request({
    url: 'Statistics/GetPersonalAvgMinsByDate',
    method: 'get',
    params: data
  })
}
export function GetPersonalScores(data) { // 个人按时间统计得分
  return request({
    url: 'Statistics/GetPersonalScores',
    method: 'get',
    params: data
  })
}
export function GetPersonalTotalProcedures(data) { // 获取个人总统计
  return request({
    url: 'Statistics/GetPersonalTotalProcedures',
    method: 'get',
    params: data
  })
}
